import { defineStore } from "pinia";
import driverJobService from "@/services/driverJobService";

export const useAdminDriverJobStore = defineStore("adminDriverJob", {
  state: () => ({
    list: [],
    total: 0,
    page: 1,
    size: 20,
    loading: false,
    error: null,

    // filters
    q: "",
    jobType: "", // PICKUP | DELIVERY | ""
    jobMode: "", // NORMAL | DIRECT_DELIVERY | ""
    xeId: null,
    taiXeId: null,
    from: "", // yyyy-mm-dd
    to: "", // yyyy-mm-dd
    sort: "createdAt,desc",
  }),

  actions: {
    async fetch() {
      this.loading = true;
      this.error = null;
      try {
        const params = {
          isAdmin: true,
          page: this.page,
          size: this.size,
          q: this.q || undefined,
          jobType: this.jobType || undefined,
          jobMode: this.jobMode || undefined,
          xeId: this.xeId || undefined,
          taiXeId: this.taiXeId || undefined,
          from: this.from || undefined,
          to: this.to || undefined,
          sort: this.sort || undefined,
        };

        const res = await driverJobService.getHistory(params);
        const root = res?.data;

        // Hỗ trợ 2 kiểu response:
        // 1) { items, total, page, size }
        // 2) mảng []
        const data = Array.isArray(root?.data) ? root.data : [];

        if (Array.isArray(data)) {
          this.list = data;
          this.total = data.length;
        } else {
          this.list = Array.isArray(data?.items) ? data.items : [];
          this.total = Number(data?.total || 0);
          this.page = Number(data?.page || this.page);
          this.size = Number(data?.size || this.size);
        }
      } catch (e) {
        this.error =
          e?.response?.data?.message ||
          e?.message ||
          "Lỗi tải lịch sử giao nhận";
      } finally {
        this.loading = false;
      }
    },

    setPage(p) {
      this.page = p;
      return this.fetch();
    },

    resetFilters() {
      this.q = "";
      this.jobType = "";
      this.jobMode = "";
      this.xeId = null;
      this.taiXeId = null;
      this.from = "";
      this.to = "";
      this.page = 1;
      return this.fetch();
    },
  },
});
